module.exports = __webpack_public_path__ + "static/media/clock.39465071.svg";